export const SUMMARY_TYPE = 'summary';
export const SELECT_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
export const MULTI_CHECKBOXES_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
export const USER_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
export const TEXT_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
export const TEXT_AREA_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
export const MULTI_SELECT_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
export const PRIORITY_TYPE = 'priority';
export const NUMBER_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
export const DATETIME_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
export const DUE_DATE_TYPE = 'duedate';
export const DESCRIPTION_TYPE = 'description';
export const CASCADING_SELECT_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
export const DATEPICKER_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
export const LABELS_TYPE = 'labels';

// trigger points
export const DEFAULT = 'default';
export const EMBEDDED_REQUEST_CREATE = 'embedded-request-create';
